var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.206,
    height: 9.231,
    viewBox: "0 0 17.206 9.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_2_-_Outline",
    "data-name": "Union 2 - Outline",
    d: "M16.5,8.5H12.654V6.683H13.6L10.766,3.448l-2.541,2.7L4.284,1.922.608,5.81-.705,4.557l5-5.287L8.231,3.492,10.814.749l3.873,4.414v-.73H16.5Z",
    transform: "translate(0.705 0.73)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeDown);
export default __webpack_public_path__ + "static/media/trade-down.42ca7128b87580fd6245adf54f07b542.svg";
export { ForwardRef as ReactComponent };